"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchFeatureExpFlagVariationSchema = exports.BatchPostFeatureExpFlagVariationSchema = exports.PostFeatureExpFlagVariationSchema = exports.FeatureExpFlagVariationWithPaginationSchema = exports.FeatureExpFlagVariationSchema = exports.FeatureExpFlagSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
const schemas_2 = require("../flag/schemas");
exports.FeatureExpFlagSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    type: schemas_2.AllowedFlagTypeEnumSchema,
    default_value: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    predefined_values: zod_1.z.union([zod_1.z.array(zod_1.z.string()), zod_1.z.array(zod_1.z.number())]),
    categories: zod_1.z.array(schemas_2.CategoriesTypeSchema),
});
exports.FeatureExpFlagVariationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    value: zod_1.z.string(),
    parsedValue: zod_1.z.union([zod_1.z.string(), zod_1.z.boolean(), zod_1.z.number(), zod_1.z.record(zod_1.z.string(), zod_1.z.any()), zod_1.z.array(zod_1.z.any())]),
    order: zod_1.z.number(),
    flag: exports.FeatureExpFlagSchema,
});
exports.FeatureExpFlagVariationWithPaginationSchema = schemas_1.FeatureExpPaginationSchema.extend({
    items: zod_1.z.array(exports.FeatureExpFlagVariationSchema),
});
const FeatureExpFlagVariationsMutationPropsSchema = zod_1.z.object({
    account_id: zod_1.z.string(),
    campaign_id: zod_1.z.string(),
    variation_group_id: zod_1.z.string(),
    variation_id: zod_1.z.string(),
});
exports.PostFeatureExpFlagVariationSchema = exports.FeatureExpFlagVariationSchema.pick({
    value: true,
    parsedValue: true,
    order: true,
    flag: true,
}).and(FeatureExpFlagVariationsMutationPropsSchema);
exports.BatchPostFeatureExpFlagVariationSchema = zod_1.z
    .object({
    flags: zod_1.z.array(zod_1.z.object({ key: zod_1.z.string(), value: exports.FeatureExpFlagVariationSchema.pick({ parsedValue: true }) })),
})
    .and(FeatureExpFlagVariationsMutationPropsSchema);
exports.PatchFeatureExpFlagVariationSchema = exports.FeatureExpFlagVariationSchema.and(FeatureExpFlagVariationsMutationPropsSchema);
//# sourceMappingURL=schemas.js.map